export default __webpack_public_path__ + "images/CRAVIATION.e0a8223.png";